var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "reviews-section": true,
        mobile: _vm.isMobile(_vm.$mq)
      }
    },
    [
      _c("h2", [_vm._v("Why people gift Brilliant Premium")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "reviews" },
        _vm._l(_vm.premiumTestimonials, function(testimonial) {
          return _c("blockquote", { key: testimonial.testimonial_id }, [
            _c("p", [_vm._v('"' + _vm._s(testimonial.text) + '"')]),
            _vm._v(" "),
            _c("p", { staticClass: "cite" }, [
              _vm._v("– " + _vm._s(testimonial.author))
            ]),
            _vm._v(" "),
            _c("span", {
              staticClass: "b-sprite-paywall-pix-stars-small stars"
            })
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }